webpackJsonp([19913542803863],{

/***/ "./src/pages/badracket.com-v1.jpg":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/badracket.com-v1.137b07c9.jpg";

/***/ }),

/***/ "./src/pages/badracket.com-v4.jpg":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/badracket.com-v4.f4a98ff3.jpg";

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/Users/adamwagner/Programming/adamwagner.io/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/Users/adamwagner/Programming/adamwagner.io/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/adamwagner/Programming/adamwagner.io/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[[\"/Users/adamwagner/Programming/adamwagner.io/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/Users/adamwagner/Programming/adamwagner.io/node_modules/babel-preset-stage-0/lib/index.js\",\"/Users/adamwagner/Programming/adamwagner.io/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/badracket.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/index.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Box = __webpack_require__("./src/components/Box.js");
	
	var _Box2 = _interopRequireDefault(_Box);
	
	var _List = __webpack_require__("./src/components/List.js");
	
	var _List2 = _interopRequireDefault(_List);
	
	var _Section = __webpack_require__("./src/components/Section.js");
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _ProjectDetail = __webpack_require__("./src/components/ProjectDetail.js");
	
	var _ProjectDetail2 = _interopRequireDefault(_ProjectDetail);
	
	var _Grid = __webpack_require__("./src/components/Grid.js");
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _GridItem = __webpack_require__("./src/components/GridItem.js");
	
	var _GridItem2 = _interopRequireDefault(_GridItem);
	
	var _vars = __webpack_require__("./src/styles/vars.json");
	
	var _badracketModule = __webpack_require__("./src/pages/badracket.module.styl");
	
	var _badracketModule2 = _interopRequireDefault(_badracketModule);
	
	var _brv5Wireframe = __webpack_require__("./src/pages/brv5-wireframe.jpg");
	
	var _brv5Wireframe2 = _interopRequireDefault(_brv5Wireframe);
	
	var _badracketComV = __webpack_require__("./src/pages/badracket.com-v1.jpg");
	
	var _badracketComV2 = _interopRequireDefault(_badracketComV);
	
	var _badracketComV3 = __webpack_require__("./src/pages/badracket.com-v4.jpg");
	
	var _badracketComV4 = _interopRequireDefault(_badracketComV3);
	
	var _brv5Possible = __webpack_require__("./src/pages/brv5-possible.gif");
	
	var _brv5Possible2 = _interopRequireDefault(_brv5Possible);
	
	var _brv5MobileWireframe = __webpack_require__("./src/pages/brv5-mobile-wireframe.jpg");
	
	var _brv5MobileWireframe2 = _interopRequireDefault(_brv5MobileWireframe);
	
	var _brv5VisualDraft = __webpack_require__("./src/pages/brv5-visual-draft-0.jpg");
	
	var _brv5VisualDraft2 = _interopRequireDefault(_brv5VisualDraft);
	
	var _brv5FinalDesktopMockup = __webpack_require__("./src/pages/brv5-final-desktop-mockup.jpg");
	
	var _brv5FinalDesktopMockup2 = _interopRequireDefault(_brv5FinalDesktopMockup);
	
	var _brv5Iphone = __webpack_require__("./src/pages/brv5-iphone.jpg");
	
	var _brv5Iphone2 = _interopRequireDefault(_brv5Iphone);
	
	var _brv5FinalInterview = __webpack_require__("./src/pages/brv5-final-interview.png");
	
	var _brv5FinalInterview2 = _interopRequireDefault(_brv5FinalInterview);
	
	var _brv5FinalShows = __webpack_require__("./src/pages/brv5-final-shows.png");
	
	var _brv5FinalShows2 = _interopRequireDefault(_brv5FinalShows);
	
	var _brv5FinalBuy = __webpack_require__("./src/pages/brv5-final-buy.png");
	
	var _brv5FinalBuy2 = _interopRequireDefault(_brv5FinalBuy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/*
	New BadRacket videos
	https://newbadracket-wpengine.netdna-ssl.com/wp-content/uploads/2015/08/Cleveland-Recording-Studio.webm
	https://newbadracket-wpengine.netdna-ssl.com/wp-content/uploads/2015/08/Cleveland-Recording-Studio.oggtheora.ogv
	https://newbadracket-wpengine.netdna-ssl.com/wp-content/uploads/2015/08/Cleveland-Recording-Studio.mp4.mp4
	*/
	
	var BadRacket = function (_React$Component) {
	  _inherits(BadRacket, _React$Component);
	
	  function BadRacket() {
	    _classCallCheck(this, BadRacket);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  BadRacket.prototype.render = function render() {
	    return _react2.default.createElement(
	      _ProjectDetail2.default,
	      { projectName: "badracket" },
	      _react2.default.createElement(
	        "div",
	        { ref: "content" },
	        _react2.default.createElement(
	          _Section2.default,
	          { reverse: true },
	          _react2.default.createElement(
	            _Grid2.default,
	            null,
	            _react2.default.createElement(
	              _GridItem2.default,
	              { leftThree: true },
	              _react2.default.createElement(
	                "h1",
	                { style: { color: _vars.colors.white } },
	                "Redesigning the web experience for Cleveland's craft recording space."
	              )
	            ),
	            _react2.default.createElement("div", { style: { gridColumn: '1 / span 2', height: '6.666px', background: 'rgba(255,255,255,0.5)' } }),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              _GridItem2.default,
	              { leftOne: true, className: "hideMobile overview" },
	              _react2.default.createElement(
	                "p",
	                { className: "projectSectionMarker", style: { textAlign: 'left' } },
	                "Overview"
	              )
	            ),
	            _react2.default.createElement(
	              _GridItem2.default,
	              { centerTwo: true, style: { marginBottom: '1.5em' } },
	              _react2.default.createElement(
	                "p",
	                null,
	                "As the founder of Bad Racket, I was responsible for much more than its website, yet I had a v1 of badracket.com before I had recorded a single band."
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "The fifth major redesign placed content produced by the studio at the forefront, enabling local music fans to preview and purchase albums and videos."
	              )
	            ),
	            _react2.default.createElement(
	              _GridItem2.default,
	              { rightOne: true, className: "hideMobile projectDetails" },
	              _react2.default.createElement(_List2.default, { title: "Client", items: ["Bad Racket Recording Studio"] }),
	              _react2.default.createElement(_List2.default, {
	                title: "Roles",
	                items: ["UX / UI design", "Content strategy", "Development"]
	              }),
	              _react2.default.createElement(_List2.default, {
	                title: "Featured on",
	                items: [{
	                  name: "HOW interactive design",
	                  href: 'http://www.howdesign.com/web-design-resources-technology/badracket-com/'
	                }, {
	                  name: "Best of Cleveland Design Awards",
	                  href: 'http://gomedia.com/zine/news/cleveland-web-and-graphic/'
	                }, {
	                  name: "Codrops",
	                  href: "https://tympanus.net/codrops/2012/12/18/a-creative-year-distinctive-web-designs-of-2012/"
	                }, {
	                  name: "Best Of Responsive Web Designs",
	                  href: 'http://www.inserthtml.com/2013/01/responsive-design-2012/'
	                }, {
	                  name: "Design Woop",
	                  href: 'http://designwoop.com/2012/08/25-examples-of-typographic-focused-web-design/'
	                }]
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Section2.default,
	          { className: _badracketModule2.default.processContainer },
	          _react2.default.createElement(
	            _Grid2.default,
	            null,
	            _react2.default.createElement(
	              "div",
	              { className: _badracketModule2.default.processItem },
	              _react2.default.createElement(
	                "p",
	                null,
	                "Discover"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Evaluate previous versions"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Understand user needs"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Set redesign goals"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Determine success criteria"
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: _badracketModule2.default.processItem },
	              _react2.default.createElement(
	                "p",
	                null,
	                "Design"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Wireframe structure"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Wireframe UX patterns"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Design visual aesthetic alongside real content"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Fine tune interactions"
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: _badracketModule2.default.processItem },
	              _react2.default.createElement(
	                "p",
	                null,
	                "Develop"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Implement vision in code"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Address unforeseen design challenges"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Tune for performance"
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: _badracketModule2.default.processItem },
	              _react2.default.createElement(
	                "p",
	                null,
	                "Measure"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Monitor success metrics"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Document performance for next iteration cycle"
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Section2.default,
	          { color: _vars.colors.white },
	          _react2.default.createElement(
	            _Grid2.default,
	            { style: { marginBottom: '1.5em' } },
	            _react2.default.createElement(
	              _GridItem2.default,
	              { leftOne: true, className: "hideMobile" },
	              _react2.default.createElement(
	                "p",
	                { className: "projectSectionMarker" },
	                "Discovery"
	              )
	            ),
	            _react2.default.createElement(
	              _GridItem2.default,
	              { centerTwo: true },
	              _react2.default.createElement(
	                "h3",
	                { style: { color: _vars.colors.red } },
	                "Evaluating previous versions"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Every redesign begins with a series of questions: Why? Is the current version underperforming? In what ways? What should be done to improve it?"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _Grid2.default,
	            { style: { marginBottom: '6em' } },
	            _react2.default.createElement(
	              _GridItem2.default,
	              { leftTwo: true },
	              _react2.default.createElement("img", { className: _badracketModule2.default.grayscale, src: _badracketComV2.default, alt: "" }),
	              _react2.default.createElement(
	                "p",
	                { className: _badracketModule2.default.textSecondaryBold },
	                "Version 1 (2009)"
	              ),
	              _react2.default.createElement(
	                "p",
	                { className: _badracketModule2.default.textSecondary },
	                "The color palette and visual aesthetic are established, but structure, usability, and performance are lacking."
	              )
	            ),
	            _react2.default.createElement(
	              _GridItem2.default,
	              null,
	              _react2.default.createElement("img", { className: _badracketModule2.default.grayscale, src: _badracketComV4.default, alt: "" }),
	              _react2.default.createElement(
	                "p",
	                { className: _badracketModule2.default.textSecondaryBold },
	                "Version 4 (2012)"
	              ),
	              _react2.default.createElement(
	                "p",
	                { className: _badracketModule2.default.textSecondary },
	                "Hierarchy and layout are improved, but the site is still text-heavy and performs poorly on mobile devices."
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _Grid2.default,
	            { style: { marginBottom: '1.5em' } },
	            _react2.default.createElement(
	              _GridItem2.default,
	              { leftOne: true, className: "hideMobile" },
	              _react2.default.createElement(
	                "p",
	                { className: "projectSectionMarker" },
	                "Discovery"
	              )
	            ),
	            _react2.default.createElement(
	              _GridItem2.default,
	              { centerTwo: true },
	              _react2.default.createElement(
	                "h3",
	                { style: { color: _vars.colors.red } },
	                "Setting redesign goals"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "By 2013, Bad Racket had produced more than thirty music videos and dozens of albums, and we wanted to show them off. "
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Our aim with the new site was to focus on content in order to ",
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "foster community"
	                ),
	                " and ",
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "increase interactivity"
	                ),
	                " with the brand."
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _Grid2.default,
	            null,
	            _react2.default.createElement(
	              _GridItem2.default,
	              { leftTwo: true },
	              _react2.default.createElement(_List2.default, {
	                title: "Foster community",
	                items: ["Social login", "Guest posts", "Band interviews", "Local show listings"]
	              })
	            ),
	            _react2.default.createElement(
	              _GridItem2.default,
	              null,
	              _react2.default.createElement(_List2.default, {
	                title: "Increase interactivity",
	                items: ["Persistent music player", "Integrated payments", "Strong mobile experience"]
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Section2.default,
	          { color: _vars.colors.offWhite },
	          _react2.default.createElement(
	            _Grid2.default,
	            { style: { marginBottom: '1.5em' } },
	            _react2.default.createElement(
	              _GridItem2.default,
	              { leftOne: true, className: "hideMobile" },
	              _react2.default.createElement(
	                "p",
	                { className: "projectSectionMarker" },
	                "Wireframing"
	              )
	            ),
	            _react2.default.createElement(
	              _GridItem2.default,
	              { centerTwo: true },
	              _react2.default.createElement(
	                "h3",
	                { style: { color: _vars.colors.red } },
	                "Wireframing UX"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Initial wireframes took a page from Spotify by putting content consumption front and center."
	              )
	            )
	          ),
	          _react2.default.createElement("img", { src: _brv5Wireframe2.default, alt: "" }),
	          _react2.default.createElement(
	            _Grid2.default,
	            null,
	            _react2.default.createElement(
	              _GridItem2.default,
	              { centerTwo: true },
	              _react2.default.createElement(
	                "p",
	                null,
	                "Bad Racket needed a vastly superior mobile experience compared to previous versions of the site, so this was a focus early on."
	              )
	            )
	          ),
	          _react2.default.createElement("img", { src: _brv5MobileWireframe2.default, alt: "" })
	        ),
	        _react2.default.createElement(
	          _Section2.default,
	          { flush: true, color: _vars.colors.offWhite },
	          _react2.default.createElement(
	            _Grid2.default,
	            null,
	            _react2.default.createElement(
	              _GridItem2.default,
	              { leftOne: true, className: "hideMobile" },
	              _react2.default.createElement(
	                "p",
	                { className: "projectSectionMarker" },
	                "Visual design"
	              )
	            ),
	            _react2.default.createElement(
	              _GridItem2.default,
	              { centerTwo: true },
	              _react2.default.createElement(
	                "h3",
	                { style: { color: _vars.colors.red } },
	                "Finding the visual style"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "With wireframes as a guideline, visual styles are defined and microinterations are tweaked. In a content-heavy design such as this, it's important to develop visuals alongside real content."
	              )
	            )
	          ),
	          _react2.default.createElement("img", { src: _brv5FinalDesktopMockup2.default, alt: "" })
	        ),
	        _react2.default.createElement(
	          _Section2.default,
	          { textColor: _vars.colors.white, color: _vars.colors.red, style: { paddingBottom: 0 } },
	          _react2.default.createElement(
	            _Grid2.default,
	            null,
	            _react2.default.createElement(
	              _GridItem2.default,
	              { centerTwo: true },
	              _react2.default.createElement(
	                "p",
	                null,
	                "Interviews were accompanied by custom illustrations done by the talented ",
	                _react2.default.createElement(
	                  "a",
	                  { target: "_blank", href: "https://dribbble.com/andrewkuhar" },
	                  "Andrew Kuhar"
	                ),
	                "."
	              )
	            )
	          ),
	          _react2.default.createElement("img", { src: _brv5FinalInterview2.default, alt: "" }),
	          _react2.default.createElement("img", { src: _brv5Iphone2.default, alt: "" })
	        ),
	        _react2.default.createElement(
	          _Section2.default,
	          { color: _vars.colors.concrete },
	          _react2.default.createElement(
	            _Grid2.default,
	            null,
	            _react2.default.createElement(
	              _GridItem2.default,
	              { centerTwo: true },
	              _react2.default.createElement(
	                "p",
	                null,
	                "Facebook integration identified loyal fans for outreach and generated social momentum around events hosted by Bad Racket."
	              )
	            )
	          ),
	          _react2.default.createElement("img", { src: _brv5FinalShows2.default, alt: "" })
	        ),
	        _react2.default.createElement(
	          _Section2.default,
	          { textColor: _vars.colors.white, color: _vars.colors.red },
	          _react2.default.createElement(
	            _Grid2.default,
	            null,
	            _react2.default.createElement(
	              _GridItem2.default,
	              { centerTwo: true },
	              _react2.default.createElement(
	                "p",
	                null,
	                "Stripe integration enabled fans to purchase albums directly from Bad Racket and encouraged bands to distribute their music through Bad Racket."
	              )
	            )
	          ),
	          _react2.default.createElement("img", { src: _brv5FinalBuy2.default, alt: "" })
	        ),
	        _react2.default.createElement(
	          _Section2.default,
	          { color: _vars.colors.white },
	          _react2.default.createElement(
	            _Grid2.default,
	            { style: { marginBottom: '4.5em' } },
	            _react2.default.createElement(
	              _GridItem2.default,
	              { leftOne: true, className: "hideMobile" },
	              _react2.default.createElement(
	                "p",
	                { className: "projectSectionMarker" },
	                "Results"
	              )
	            ),
	            _react2.default.createElement(
	              _GridItem2.default,
	              { centerTwo: true },
	              _react2.default.createElement(
	                "h3",
	                { style: { color: _vars.colors.red } },
	                "Key results"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "The redesigned badracket.com was faster, content forward, and engaging."
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Facebook login plus Mixpanel allowed for a tailored experience and timely followup via drip email."
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Stripe integration helped fans support local bands."
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Attendance at Bad Racket's hosted shows grew, as did the post-show social media engagement."
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return BadRacket;
	}(_react2.default.Component);
	
	exports.default = BadRacket;
	module.exports = exports["default"];

/***/ }),

/***/ "./src/pages/badracket.module.styl":
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hide--mobile":"src-pages----badracket-module---hide--mobile---37DKK","show--mobile":"src-pages----badracket-module---show--mobile---3Myot","hide--tablet":"src-pages----badracket-module---hide--tablet---1Qa7d","show--tablet":"src-pages----badracket-module---show--tablet---2wnRq","hide--desk":"src-pages----badracket-module---hide--desk---2wwgl","show--desk":"src-pages----badracket-module---show--desk---1nTTt","hide--huge":"src-pages----badracket-module---hide--huge---1bayD","show--huge":"src-pages----badracket-module---show--huge---1wXPz","textSecondary":"src-pages----badracket-module---textSecondary---2bMyh","textSecondaryBold":"src-pages----badracket-module---textSecondaryBold---3yg1T","processContainer":"src-pages----badracket-module---processContainer---1vRtD","textBold":"src-pages----badracket-module---textBold---1cSuI","process":"src-pages----badracket-module---process---37Ga5","processItem":"src-pages----badracket-module---processItem---20vp3"};

/***/ }),

/***/ "./src/pages/brv5-final-buy.png":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/brv5-final-buy.a7319fcc.png";

/***/ }),

/***/ "./src/pages/brv5-final-desktop-mockup.jpg":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/brv5-final-desktop-mockup.18eec238.jpg";

/***/ }),

/***/ "./src/pages/brv5-final-interview.png":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/brv5-final-interview.a0daf790.png";

/***/ }),

/***/ "./src/pages/brv5-final-shows.png":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/brv5-final-shows.d563da3c.png";

/***/ }),

/***/ "./src/pages/brv5-iphone.jpg":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/brv5-iphone.54385a99.jpg";

/***/ }),

/***/ "./src/pages/brv5-mobile-wireframe.jpg":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/brv5-mobile-wireframe.80a2e60c.jpg";

/***/ }),

/***/ "./src/pages/brv5-possible.gif":
/***/ (function(module, exports) {

	module.exports = "data:image/gif;base64,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"

/***/ }),

/***/ "./src/pages/brv5-visual-draft-0.jpg":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/brv5-visual-draft-0.9ec252c5.jpg";

/***/ }),

/***/ "./src/pages/brv5-wireframe.jpg":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/brv5-wireframe.17a6bd50.jpg";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-badracket-js-683780d9c528b3ccfd41.js